import { Button, Form, Input, InputNumber, Select, Space, Switch } from 'antd';
import { useEffect, useState } from 'react';
import getList from '../universal/getList';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
// import systemConfig from '../../config/systematic';

//  主配料formList通用组件
export default function WebSetMealIngredientFormList(props: any) {

    const { formName, branchStoreId, isBase, tempDeleteData, refreshData } = props;
    const { form, type, ref, setIngredientDetailData, setTempDeleteData, setPersent, setRefreshData } = props.props;

    const formListData = Form.useWatch(formName, form) as any;

    /** 菜式数据 */
    const [branchStoreMenuWarehouseData, setBranchStoreMenuWarehouseData] = useState<any>();

    /** 后端数据wmService */
    // let wmService: any = systemConfig.wmService;

    useEffect(() => {
        if (ref.current) {
            ref.current.row.then(async (res: any) => {
                if (typeof res === 'undefined') { return }
                if (res.success === true) {
                    await setBaseData(res);
                }
            })
        }

        const fetchData = async () => {

        }
        fetchData()
    }, [])

    const setBaseData = async (res: any) => {
        let ingredientObj: any = {};
        //自定义formList数据初始状态
        let newData: Array<any> = [];
        // console.log("---------------------返回的数据------------------------");
        // console.log(res.data);

        if (isBase) {
            for (var i = 0; i < res.data.rowsDetail.length; i++) {
                ingredientObj[i] = [{
                    id: res.data.rowsDetail[i].branchStoreMenuWarehouseSpecId,
                    value: res.data.rowsDetail[i].branchStoreMenuWarehouseSpecId,
                    branchStoreMenuWarehouseSpecName: res.data.rowsDetail[i].branchStoreMenuWarehouseSpec.branchStoreMenuWarehouseSpecName,
                    costPrices: res.data.rowsDetail[i].totals,
                    branchStoreMenuWarehouseId: res.data.rowsDetail[i].branchStoreMenuWarehouseId,
                    foodName: res.data.rowsDetail[i].branchStoreMenuWarehouse.foodName,
                    label: res.data.rowsDetail[i].branchStoreMenuWarehouse.mergeFoodName,
                }]

                if (type !== "NEW") {
                    newData.push({
                        id: res.data.rowsDetail[i].id,
                        ingredientId: res.data.rowsDetail[i].ingredientId,
                        branchStoreMenuWarehouse: res.data.rowsDetail[i].branchStoreMenuWarehouse.mergeFoodName,
                        branchStoreMenuWarehouseSpecName: res.data.rowsDetail[i].branchStoreMenuWarehouseSpec.branchStoreMenuWarehouseSpecName,
                        branchStoreMenuWarehouseId: res.data.rowsDetail[i].branchStoreMenuWarehouseId,
                        branchStoreMenuWarehouseSpecId: res.data.rowsDetail[i].branchStoreMenuWarehouseSpecId,
                        amounts: res.data.rowsDetail[i].amounts,
                        yieldRatio: res.data.rowsDetail[i].yieldRatio,
                        unitPrice: res.data.rowsDetail[i].unitPrice,
                        totals: res.data.rowsDetail[i].totals,
                        autoUpdate: res.data.rowsDetail[i].autoUpdate,
                        baseUnitPrice: res.data.rowsDetail[i].unitPrice,
                        memo: res.data.rowsDetail[i].memo,
                        state: "origin"
                    })
                }
            }

            // console.log(ingredientObj);
            // console.log("ingredientObj");
            // console.log(ingredientObj1[0] ? ingredientObj1 : "1");
            // console.log("newData", newData);

            form.setFieldsValue({ [formName]: newData });
            setBranchStoreMenuWarehouseData(ingredientObj);
        }
    };

    const mergeIngredientDetail = (delData: any) => {
        let ingredientDetail: any;
        let costPrices: any = 0;
        let str_data = "setMealDetails";

        if (ingredientDetail) {
            if (form.getFieldsValue()[str_data]) {
                ingredientDetail = ingredientDetail.concat(form.getFieldsValue()[str_data]);
            }
        }
        else {
            ingredientDetail = form.getFieldsValue()[str_data];
        }

        // 计算总成本价格
        for (var i_costPrices = 0; i_costPrices < ingredientDetail.length; i_costPrices++) {
            costPrices = Number(costPrices) + Number(ingredientDetail[i_costPrices].totals !== undefined ? ingredientDetail[i_costPrices].totals : 0);
        }

        // console.log("------------------合并时，收到需要删除的数据------------------");
        // console.log(delData);

        if (delData) {
            ingredientDetail = ingredientDetail.concat(delData);
        }

        // console.log("------------------最后的总数据------------------");
        // console.log(ingredientDetail);

        setIngredientDetailData(ingredientDetail);
        form.setFieldsValue({ costPrices: costPrices.toFixed(3) });
        setPersent(form, form.getFieldValue("sellPrice"));
    };

    if (refreshData) {
        // console.log("------------refreshData----------------");
        mergeIngredientDetail(tempDeleteData);
        setRefreshData(false);
    }

    //remove 删除
    const removeList = (remove: Function, num: number, key: number, originData: any) => {

        //即将删除的数据
        let removeData = form.getFieldsValue()[formName][num];
        let concatData: any;

        if (removeData && removeData.id) {

            let addDeleteData: any;
            addDeleteData = { ...removeData, state: "delete" };

            if (originData) {
                originData.push(addDeleteData);
                concatData = originData;
            }
            else {
                let tmpData: any = [];
                tmpData.push(addDeleteData);
                concatData = tmpData;
            }

            setTempDeleteData(concatData);
        }
        else {
            if (originData) {
                concatData = originData;
            }

            setTempDeleteData(concatData);
        }

        remove(num);
        mergeIngredientDetail(concatData);
        
        if (branchStoreMenuWarehouseData) {
            delete branchStoreMenuWarehouseData[key];
        }
    }

    const customizeAdd = (add: Function, originData: any) => {
        add();
        form.setFieldValue([formName, form.getFieldsValue()[formName].length - 1], { ingredientId: 99, state: "insert" });
        mergeIngredientDetail(originData);
    }

    /**将修改的内容的状态改为update 并和 需要删除的数据进行合并*/
    const handleChange = async (form: any, e: any, name?: any, FormListName?: string, type?: string, originData?: any, key?: any, option?: any) => {
        if (key === 'branchStoreMenuWarehouse') {
            form.setFieldValue([FormListName, name, "branchStoreMenuWarehouseId"], option.branchStoreMenuWarehouseId);
            form.setFieldValue([FormListName, name, "branchStoreMenuWarehouseSpecId"], option.id);
            form.setFieldValue([FormListName, name, "unitPrice"], option.costPrices);
            form.setFieldValue([FormListName, name, "baseUnitPrice"], option.costPrices);
            form.setFieldValue([FormListName, name, "foodName"], option.foodName);
            form.setFieldValue([FormListName, name, "branchStoreMenuWarehouseSpecName"], option.branchStoreMenuWarehouseSpecName);

            //获取该菜式信息，把规格找出来，如果只有一个规格自动填入
            // fetchApi.GET(wmService, {
            //     apiId: 'branchStoreMenuWarehouseSpec',
            //     apiExtend: 'checkBranchStoreMenuWarehouseSpec',
            //     branchStoreMenuWarehouseId: option.branchStoreMenuWarehouseId,
            // }).then(res => {
            //     if (res.success) {
            //         setBranchStoreMenuWarehouseSpecData(res.data);
            //         if (res.data.length === 1) {
            //             form.setFieldValue([FormListName, name, "branchStoreMenuWarehouseSpecId"], res.data[0].id);
            //             form.setFieldValue([FormListName, name, "unitPrice"], res.data[0].menuWarehouseIngredients.length > 0 ? res.data[0].menuWarehouseIngredients[0].costPrices : null);
            //             form.setFieldValue([FormListName, name, "baseUnitPrice"], res.data[0].menuWarehouseIngredients.length > 0 ? res.data[0].menuWarehouseIngredients[0].costPrices : null);
            //             // form.setFieldValue([FormListName, name, "foodName"],  res.data[0].branchStoreMenuWarehouse.foodName });
            //             // form.setFieldValue([FormListName, name, "branchStoreMenuWarehouseSpecName"],  res.data[0].branchStoreMenuWarehouseSpecName });
            //         }
            //         else {
            //             form.setFieldValue([FormListName, name, "branchStoreMenuWarehouseSpecId"], null);
            //             form.setFieldValue([FormListName, name, "unitPrice"], null);
            //             form.setFieldValue([FormListName, name, "baseUnitPrice"], null);
            //         }
            //     }
            // });
        }

        await totalize(form, name, FormListName, type, originData);
    }

    const totalize = (form: any, name?: any, FormListName?: string, type?: string, originData?: any) => {
        let amounts = form.getFieldValue([FormListName, name, "amounts"]);
        let yieldRatio = form.getFieldValue([FormListName, name, "yieldRatio"]);
        let unitPrice = form.getFieldValue([FormListName, name, "unitPrice"]);
        let baseUnitPrice = form.getFieldValue([FormListName, name, "baseUnitPrice"]);

        if (unitPrice !== baseUnitPrice) {
            form.setFieldValue([FormListName, name, "autoUpdate"], false);
        }

        let newTotalPrice = Number(amounts) * Number(unitPrice) / Number(yieldRatio) * 100;

        //设置总价格
        form.setFieldValue([FormListName, name, "totals"], newTotalPrice.toFixed(3));

        if (type === "EDIT") {
            form.setFieldValue([FormListName, name], { ...form.getFieldsValue()[FormListName!][name], state: form.getFieldsValue()[FormListName!][name].id ? "update" : "insert" })
        }
        mergeIngredientDetail(originData);
    }

    return (
        <>
            <Form.List name={formName}>
                {(fields, { add, remove }) => {
                    return (
                        <>
                            {fields.map(({ key, name, ...restField }) => (
                                <Space
                                    key={key}
                                    style={{ display: 'flex', marginBottom: 8 }}
                                    align="baseline"
                                >
                                    <Form.Item
                                        {...restField}
                                        // label="菜式"
                                        name={[name, 'branchStoreMenuWarehouse']}
                                        rules={[{
                                            required: true,
                                            message: '请输入菜式',
                                        }]}
                                    >
                                        <Select
                                            style={{ width: 250 }}
                                            disabled={formListData ? formListData[name] ? formListData[name].state === "insert" ? false : true : true : true}
                                            showSearch
                                            allowClear
                                            onSearch={(e) => getList.searchEx('branchStoreMenuWarehouseSpec', setBranchStoreMenuWarehouseData, e, branchStoreMenuWarehouseData, {
                                                apiExtend: 'showListForIngredient',
                                                keyId: key,
                                                isFormList: true,
                                                form,
                                                FormListName: formName,
                                                name,
                                                andWhereObj: {
                                                    branchStoreId,
                                                    mountDataOptions: {
                                                        userMount: {
                                                            isDept: true
                                                        }
                                                    }
                                                }
                                            })}
                                            onChange={(e, option) => handleChange(form, e, name, formName, type, tempDeleteData, 'branchStoreMenuWarehouse', option)}
                                            placeholder="菜式"
                                            optionFilterProp="children"
                                            filterOption={(input, option: any) => {
                                                return true
                                            }}
                                            options={branchStoreMenuWarehouseData ? branchStoreMenuWarehouseData[key] ? branchStoreMenuWarehouseData[key] : [] : []}
                                        >
                                            {/* {getList.general(branchStoreMenuWarehouseData ? branchStoreMenuWarehouseData[key] ? branchStoreMenuWarehouseData[key] : [] : [], "foodName")} */}
                                        </Select>
                                    </Form.Item>

                                    {/* <Form.Item
                                        label="菜式"
                                        {...restField}
                                        name={[name, 'branchStoreMenuWarehouseId']}
                                        rules={[
                                            {
                                                required: true,
                                                message: '请输入菜式',
                                            },
                                        ]}
                                    >
                                        <Input
                                            disabled
                                            style={{ width: 80 }}
                                            placeholder="菜式"
                                        />
                                    </Form.Item>

                                    <Form.Item
                                        {...restField}
                                        label="规格"
                                        name={[name, 'branchStoreMenuWarehouseSpecId']}
                                        rules={[{
                                            required: true,
                                            message: '请输入规格',
                                        }]}
                                    >
                                        <Input
                                            disabled
                                            style={{ width: 80 }}
                                            placeholder="规格"
                                        />
                                    </Form.Item> */}

                                    <Form.Item
                                        {...restField}
                                        // label="规格"
                                        name={[name, 'branchStoreMenuWarehouseSpecName']}
                                    >
                                        <Input
                                            disabled
                                            style={{ width: 85 }}
                                            placeholder="规格"
                                        />
                                    </Form.Item>

                                    <Form.Item
                                        // label="定量"
                                        {...restField}
                                        name={[name, 'amounts']}
                                        rules={[
                                            {
                                                required: true,
                                                message: '请输入定量',
                                            },
                                        ]}
                                    >
                                        <InputNumber
                                            style={{ width: 80 }}
                                            onChange={(e) => handleChange(form, e, name, formName, type, tempDeleteData)}
                                            placeholder="定量"
                                            min={0.001}
                                            step={0.001}
                                        />
                                    </Form.Item>

                                    <Form.Item
                                        // label="起率"
                                        {...restField}
                                        initialValue={100}
                                        name={[name, 'yieldRatio']}
                                        rules={[
                                            {
                                                required: true,
                                                message: '请输入起率',
                                            },
                                        ]}
                                    >
                                        <InputNumber
                                            disabled
                                            style={{ width: 100 }}
                                            onChange={(e) => handleChange(form, e, name, formName, type, tempDeleteData)}
                                            placeholder="起率"
                                            min={0.01} />
                                    </Form.Item>

                                    <Form.Item
                                        // label="单价"
                                        {...restField}
                                        name={[name, 'unitPrice']}
                                        rules={[
                                            {
                                                required: true,
                                                message: '请输入单价',
                                            },
                                        ]}
                                    >
                                        <InputNumber
                                            disabled
                                            style={{ width: 80 }}
                                            onChange={(e) => handleChange(form, e, name, formName, type, tempDeleteData)}
                                            placeholder="单价"
                                            min={0} />
                                    </Form.Item>

                                    <Form.Item
                                        // label="金额"
                                        {...restField}
                                        name={[name, 'totals']}
                                        rules={[
                                            {
                                                required: true,
                                                message: '请输入金额',
                                            },
                                        ]}
                                    >
                                        <InputNumber
                                            style={{ width: 80, color: "yellow" }}
                                            disabled
                                            onChange={(e) => handleChange(form, e, name, formName, type, tempDeleteData)}
                                            placeholder="金额"
                                            min={0} />
                                    </Form.Item>

                                    <Form.Item
                                        // label="自动更新"
                                        {...restField}
                                        name={[name, 'autoUpdate']}
                                    >
                                        <Switch
                                            style={{ width: 110 }}
                                            disabled
                                            defaultChecked
                                            onChange={(e) => handleChange(form, e, name, formName, type, tempDeleteData)}
                                            checkedChildren="单价自更新"
                                            unCheckedChildren="单价不自更新" />
                                    </Form.Item>

                                    <Form.Item
                                        // label="备注"
                                        {...restField}
                                        name={[name, 'memo']}
                                    >
                                        <Input
                                            style={{ width: 220 }}
                                            onChange={(e) => handleChange(form, e, name, formName, type, tempDeleteData)}
                                            placeholder="备注"
                                        />
                                    </Form.Item>

                                    <MinusCircleOutlined onClick={() => removeList(remove, name, key, tempDeleteData)} />
                                </Space>
                            ))}
                            <Form.Item>
                                <Button
                                    type="dashed"
                                    onClick={() => customizeAdd(add, tempDeleteData)}
                                    block
                                    icon={<PlusOutlined />}
                                >
                                    添加
                                </Button>
                            </Form.Item>
                        </>
                    )
                }
                }
            </Form.List>
        </>
    )
}